// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Overlay_Overlay__14FeO","panel":"Overlay_panel__3n6hN","active":"Overlay_active__1nmP_"};